import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

import {
    presQuestion2022Mixin
} from './vue/mixins/pres-questions-2022';
const mixins = [];
mixins.push(presQuestion2022Mixin);
initMain(mixins, {});
header();